import $ = require("jquery");
import _ = require("underscore");
import Portal = require("portal-gis");
import Utils = require("../../utils");
import geo = require("../../utils/geo");
import View = require("../view");
import IPS = require("publicsector");
import Query = require("arcgis/services/featureserver/query");
import GeoQueryControlFactory = require("../geoquery-controlfactory");

function cast(value, type: string) {
    switch (type) {
        case "date": {
            let result = new Date(value);
            return isNaN(result.getTime()) ? value : result;
        }
        case "number": {
            let result = parseFloat(value);
            return isNaN(result) ? value : result;
        }
        case "string": {
            return (value || "").toString();
        }
        default: {
            return value;
        }
    }
}

class Tool extends View {

    private _metadata: Array<Rhythm.GIS.FieldInfo>;
    private _form: JQuery;
    private factory = new GeoQueryControlFactory();

    static about = `
Creates a filter form from metadata.
    `;

    static options = {
        "blacklist": {
            "about": "any control id's matching the metadata are considered field overrides, disabled fields are blacklisted",
        },
        "metadata": {
            "about": "if metadata already provided we do not need to discover it",
        },
        "query-service": {
            "about": "service endpoint(s)",
        },
        "whitelist":{
            "about": "remove fields not in whitelist (if there is a whitelist)",
        },
    }

    get metadata() {
        return this._metadata;
    }

    get form() {
        return this._form;
    }

    // TODO: too confusing how all this ties together, diagram the call sequence and simplify
    createView() {
        // need a template and view capable of rendering args.form
        _.defaults(this.options, {
            template: "app/templates/tabs-form-template"
        });
        // super.createView() will broadcast() existance of view, initiate register()ation process
        super.createView();
    }

    // list for 'form', initiate the form creation process
    register() {
        // initiate the form creation process
        let options = this.options;
        let metadata = options["metadata"];
        // if metadata already provided we do not need to discover it (via re-implementations of createForm)
        this.createForm(metadata ? { metadata: JSON.parse(metadata) } : null);
        // !!!DO NOT CALL super.register() UNTIL CREATEFORM IS DONE!!!
        // super.register(); <- see createForm() where this gets called...FIX THIS CONFUSION!
    }

    private get whitelist(): Array<string> {
        let list = this.options["whitelist"];

        // not defined so everything is allowed
        if (typeof list === "undefined") return null;

        // no items so nothing is allowed
        if (list === "") return [];

        // contains a comma, assume it is a list (as expected)
        if (0 < list.indexOf(",")) return Utils.split(list);

        // no comma so it only contains one field
        return [list];
    }

    private get blacklist(): Array<string> {
        let list = this.options["blacklist"];

        // any control id's matching the metadata are considered field overrides, disabled fields are blacklisted
        let blacklist = this.configuration.Controls.Controls.filter(c => c.disabled).map(c => c.id);

        // not defined so nothing is excluded
        if (typeof list === "undefined") return blacklist;

        // no items so nothing is excluded
        if (list === "") return blacklist;

        // contains a comma, assume it is a list (as expected)
        if (0 < list.indexOf(",")) return Utils.split(list).concat(blacklist);

        // no comma so it only contains one field
        blacklist.push(list);
        return blacklist;
    }

    registerControls(controls: Portal.ControlsElement) {
        // for this form tool we're allowing the input control to be replaced when a child control matching the field
        // id is found.  For example, <CONTROL mid="app/test/controls/daterange" id="ExpireDateTime" /> will render
        // the daterange control instead of the control generated by the geoquery-controlfactory
        return super.registerControls(controls).done(args => {
            let subFields = this.metadata.map(fi => args.modules.filter(m => m.id === fi.name)[0]).filter(mod => !!mod);

            // remove fields not in whitelist (if there is a whitelist)
            let whitelist = this.whitelist;
            if (whitelist) {
                subFields = subFields.filter(fi => 0 <= whitelist.indexOf(fi.id));
            }

            // remove fields in blacklist (if there is a blacklist)
            let blacklist = this.blacklist;
            if (blacklist) {
                subFields = subFields.filter(fi => 0 > blacklist.indexOf(fi.id));
            }

            if (subFields.length) {
                console.log("replace built-in fields with subFields");
                subFields.forEach(c => {
                    // TODO: I know these are "fake" controls at the moment and $el is ready to use
                    // but this should handle controls with real views
                    let metadata = this.metadata.filter(fi => fi.name === c.id)[0];
                    if (metadata) {
                        let htmlControl = new args.factory[c.mid](c, this.mediator, {
                            controller: this,
                            fieldInfo: metadata
                        });
                        this.factory.replace(metadata, htmlControl);
                    }
                });

            }
        });
    }

    createForm(args?: { metadata: Array<Rhythm.GIS.FieldInfo> }) {
        if (!args) return;
        let options = this.options;

        this._metadata = args.metadata;

        // assign default values
        {
            let defaultValues = options;
            Utils.ifOption(options, "default-values", v => defaultValues = JSON.parse(v));

            args.metadata.forEach(item => {

                Utils.ifOption(defaultValues, item.name, defaultValue => {
                    console.log("assigning default value for field: ", item);
                    Utils.extend(item, {
                        defaultValue: cast(defaultValue, item.type)
                    });
                });
            });
        }

        // create form with controls and broadcast it's existence
        {
            let form = this._form = this.factory.asForm();
            let subFields = args.metadata;
            {
                // remove fields not in whitelist (if there is a whitelist)
                let whitelist = this.whitelist;
                if (whitelist) {
                    subFields = subFields.filter(fi => 0 <= whitelist.indexOf(fi.name));
                }

                // remove fields in blacklist (if there is a blacklist)
                let blacklist = this.blacklist;
                if (blacklist) {
                    subFields = subFields.filter(fi => 0 > blacklist.indexOf(fi.name));
                }

            }
            let controls = subFields.map(fieldInfo => this.factory.asControl(fieldInfo));
            controls.forEach(c => c.appendTo(form));

            // add it to the views collection
            // provide the content of the view as the first and only collection item
            this.view.collection.merge({
                id: this.configuration.id
            });

            // render the view
            this.view.render();
            $(`#${this.configuration.id}`, this.view.$el).append(this.form);

            // register sub-controls and commands (placed here to reduce promises...gets confusing)
            super.register();
        }

    }

    asData(view = this.view) {
        let data = this.metadata.map(fieldInfo => {
            let name = fieldInfo.name;
            let id = this.factory.asId(fieldInfo);
            let value = this.factory.getValue(this.form, fieldInfo);
            return {
                name: fieldInfo.name,
                value: value,
                fieldInfo: fieldInfo
            }
        });
        return data.filter(item => item.value !== null);
    }

    getServices(serviceInfo: Rhythm.GIS.Dictionary<string>) {
        let service = this.options["query-service"];
        if (!service) {
            // TODO: why would we ever put the query-service on the handler instead of the control?  Same form multiple types of search?
            service = serviceInfo["query-service"];
        }
        return service ? Utils.split(service) : [];
    }

    processResults(results: Array<IPS.GeoEntity>) {
        let serviceInfo = _.defaults(this.options, {
            srs: "EPSG:4326",
            locatingproperties: "address,property,parcel"
        });

        let layer = <Rhythm.GIS.FeatureQueryResultLayer>{
            spatialReference: {
                wkid: <any>serviceInfo["srs"]
            },
            features: []
        };

        if (!results.length) {
            console.log("no results to process");
            return layer;
        }

        layer.features = results.map(item => {
            geo.beforeProcess({ data: item }, serviceInfo["locatingproperties"]);

            if (geo.isPoint(item)) {
                return {
                    attributes: item,
                    geometryType: "point",
                    geometry: [item.xCoordinate, item.yCoordinate]
                }
            }
            return {
                attributes: <any>item
            };
        });

        if (serviceInfo["metadata"]) {
            var metadata = <Array<Query.Field>>JSON.parse(serviceInfo["metadata"]);
            metadata = metadata.filter(m => m.type !== null);
        } else {
            let feature = layer.features.filter(f => !!f.attributes)[0];
            if (feature) {
                let f = feature.attributes;
                metadata = _.keys(f).map(attr => ({
                    name: attr,
                    alias: attr,
                    type: typeof f[attr]
                }));
            }
        }

        if (metadata) {
            layer.fields = metadata.filter(m => m.type === "string");
        }

        Utils.ifOption(serviceInfo, "symbology", v => {
            // assign layer-level symbology
            Utils.extend(layer, {
                symbology: v
            });
            // assign feature-level symbology if not already set
            layer.features.forEach(f => _.defaults(Utils.extend(f), {
                symbology: v
            }));
        });

        this.trigger({
            layers: [layer]
        });

        return layer;
    }

}

export = Tool;
